<template>
    <record-delete-item
        v-bind:recordData="source"
        v-bind:itemFunc="clickSearchResultRItem">
    </record-delete-item>
</template>

<script>
import RecordDeleteItem from '../record/RecordDeleteItem.vue'
export default {
    name: 'SearchResultRItem',
    components: { RecordDeleteItem },
    props: {
        source: {   
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        clickSearchResultRItem(recordData) {
            var personInfo = this.$store.state.record.recordOriginalData[recordData.id];
            this.$store.dispatch('detail/initDetail', personInfo);
            // 更新列表数据
            this.$store.dispatch('record/updateRecordListData', personInfo);
            this.$router.replace('/detail/search_result/'+ personInfo.id);
        }
    }
}
</script>